module.exports = __webpack_public_path__ + "static/img/Alfian Azizi-full.b65e3ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/full/Alfian Azizi-full.png
// module id = bVV0
// module chunks = 1